@if (visible()) {
<section class="ui-toast" [attr.data-type]="type()" [attr.role]="ariaRole()" [attr.aria-live]="type() === 'error' ? 'assertive' : 'polite'">
    <span class="ui-toast__icon material-symbols-rounded" aria-hidden="true">{{ iconSymbol() }}</span>

    <div class="ui-toast__content">
      <strong>{{ title() | uiLabelTranslate }}</strong>
      <p>{{ message() | uiLabelTranslate }}</p>
    </div>

    <button class="ui-toast__close" type="button" (click)="dismiss.emit()" [attr.aria-label]="'shared.close' | uiLabelTranslate">
      <span class="material-symbols-rounded" aria-hidden="true">close</span>
    </button>
  </section>
}
